import { createSelector } from "reselect";

const selectTopic = (state) => state.topic;

export const selectTopicList = createSelector(
  [selectTopic],
  (topic) => topic.topics
);

export const selectTopicLoading = createSelector(
  [selectTopic],
  (topic) => topic.isLoading
);

export const selectIsFetchingTopics = createSelector(
  [selectTopic],
  (topic) => topic.isFetchingTopics
);

export const selectIsDeletingTopics = createSelector(
  [selectTopic],
  (topic) => topic.isDeletingTopic
);
